"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupStatus = void 0;
var GroupStatus = /*#__PURE__*/function (GroupStatus) {
  GroupStatus["Active"] = "active";
  GroupStatus["ComingSoon"] = "coming-soon";
  GroupStatus["Archived"] = "archived";
  return GroupStatus;
}({});
exports.GroupStatus = GroupStatus;